import DefaultProjectDetailView from "src/components/feature/ProjectDetailView/LandOwnershipDetails";

const LandOwnerShipDetailView = () => {
  return <DefaultProjectDetailView />;
};

export default LandOwnerShipDetailView;
